import { Popover } from "@/components/Popover/Popover";
import WarningTriangleIcon from "@medoma/components/icons/WarningTriangleIcon";
import styles from "./WarningIconPopover.module.scss";

export const WarningIconPopover = ({
  ariaLabel,
  children,
}: {
  ariaLabel: string;
  children: React.ReactNode;
}) => {
  return (
    <Popover
      trigger={{
        custom: (
          <div className={styles.warningIcon}>
            <WarningTriangleIcon />
          </div>
        ),
        ariaLabel,
      }}
    >
      {children}
    </Popover>
  );
};
